









import Vue from 'vue';
export default Vue.extend({
    props: {
        tooltip: {
            type: String,
            default: '',
        },
    },
    data: function() {
        return {
            tippyOptions: {
                theme: 'ims-tooltip',
                arrow: true,
                placement: 'top',
                boundary: 'viewport',
                delay: [500, 20],
            },
        };
    },
});
